import { useMutation } from 'react-query';
import AsnAPI from '../../Api/asn';
import { AsnSaveFormData } from '../../../Components/ASN/schemas/asnConfiguration.schema';

/**
 * Persists ASN configuration (shipment details, etc.) for an existing ASN.
 *
 * @param userId - User identifier.
 * @param asnNumber - ASN identifier.
 * @returns React Query mutation; call `mutate` with {@link AsnSaveFormData}.
 */
export const useSaveAsnConfiguration = (userId: string, asnNumber: string) =>
  useMutation((data: AsnSaveFormData) =>
    AsnAPI.saveAsnConfiguration(userId, asnNumber, data),
  );
